<template>
    <div class="cc-carriers">
        <div class="cc-carriers__header">
            <div class="cc-carriers__title">{{ translations['Carriers'] }}</div>
            <a class="cc-carriers__change cc-link" v-if="isAnyCarrierSelected" @click="unsetCarrier">{{ translations['Change carrier'] }}</a>
        </div>
        <div class="cc-carriers__main" v-if="shouldCarriersBeShown">
            <carrier v-for="carrier in carriers" v-bind:key="carrier.id_carrier" :carrier="carrier"/>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Carrier from "./Carrier";

    export default {
        components: {
            Carrier,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedCountry: state => state.user.deliveryAddress.country,
                carriers: state => state.carriers,
                selectedCarrier: state => state.selectedCarrier,
            }),
            shouldCarriersBeShown: function () {
                return this.selectedCountry !== null && this.selectedCountry !== '' && this.carriers && this.carriers.length > 0;
            },
            isAnyCarrierSelected: function () {
                return this.selectedCarrier !== null && this.selectedCarrier !== '';
            },
        },
        methods: {
            unsetCarrier: function () {
                this.$store.dispatch('SELECT_CARRIER', null);
                this.$store.dispatch('SELECT_PAYMENT', null);
            },
        },
        name: 'Carriers',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/carriers";
</style>
